import axiosInstance from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import { responseDataFormate } from "../../helpers/bycrypt";

export const GetDeliveryZoneListAPI =
  (page: number, limit: number, search?: string) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDeliveryPricing", true);
    axiosInstance
      .get(`/delivery-zone-price`, {
        params: { page, limit, search, order: "order | desc" },
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_DELIVERY_PRICING_DATA",
            payload: {
              data: result?.data || [],
              count: result?.totalCount || result?.data?.length || 0,
              page,
            },
          });
        } else {
          elseHandler(dispatch, "getDeliveryPricing", result);
        }
        dispatchLoading(dispatch, "getDeliveryPricing", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDeliveryPricing")(err);
      });
  };

export const CreateDeliveryZoneAPI =
  (data: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "createZone", true);
    axiosInstance
      .post(`/delivery-zone-price`, data, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success || response.status === 201) {
          dispatchToast(dispatch, "success", result?.message || "Delivery zone created successfully");
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "createZone", result);
        }
        dispatchLoading(dispatch, "createZone", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "createZone")(err);
      });
  };

export const UpdateDeliveryZoneAPI =
  (id: string, data: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "createZone", true);
    axiosInstance
      .put(`/delivery-zone-price/${id}`, data, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success || response.status === 200) {
          dispatchToast(dispatch, "success", result?.message || "Delivery zone updated successfully");
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "createZone", result);
        }
        dispatchLoading(dispatch, "createZone", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "createZone")(err);
      });
  };

export const DeleteDeliveryZoneAPI =
  (id: string, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteZone", true);
    axiosInstance
      .delete(`/delivery-zone-price/${id}`, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success || response.status === 200) {
          dispatchToast(dispatch, "success", result?.message || "Delivery zone deleted successfully");
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "deleteZone", result);
        }
        dispatchLoading(dispatch, "deleteZone", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteZone")(err);
      });
  };

export const GetDeliveryMarkupAPI =
  (onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDeliveryMarkup", true);
    axiosInstance
      .get(`/delivery-markup-price`, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success || response.status === 200) {
          dispatch({
            type: "GET_DELIVERY_MARKUP_DATA",
            payload: (result?.data && result.data.length > 0) ? result.data[0].percentage : 0,
          });
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "getDeliveryMarkup", result);
        }
        dispatchLoading(dispatch, "getDeliveryMarkup", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDeliveryMarkup")(err);
      });
  };

export const UpdateDeliveryMarkupAPI =
  (data: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDeliveryMarkup", true);
    axiosInstance
      .put(`/delivery-markup-price`, data, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success || response.status === 200) {
          dispatchToast(dispatch, "success", result?.message || "Markup updated successfully");
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "updateDeliveryMarkup", result);
        }
        dispatchLoading(dispatch, "updateDeliveryMarkup", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updateDeliveryMarkup")(err);
      });
  };

export const ReorderDeliveryZoneAPI =
  (data: { id: string; order: number; country_id?: string }, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderZone", true);
    axiosInstance
      .put(`/delivery-zone-price/reorder`, data, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success || response.status === 200) {
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "reorderZone", result);
        }
        dispatchLoading(dispatch, "reorderZone", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "reorderZone")(err);
      });
  };
